import React from "react";
import _ from "lodash";

import { Skeleton } from "antd";
import { Transfer } from "misc/transfer";
import { usePermissions } from "misc/api/keycloakApi";

const PermissionsTransfer = ({ client = null, permissionPrefix = "permission_", ...props }) => {
    const { permissions, isLoading } = usePermissions([client]);

    if (isLoading) {
        return <Skeleton paragraph={{ rows: 4 }} />;
    }

    return (
        <Transfer
            dataSource={permissions
                .filter(permission => permission.name.includes(permissionPrefix) & (permission.client === client))
                .map(permission => ({
                    key: permission.id,
                    title: _.isEmpty(permission.description) ? permission.name : permission.description
                }))}
            filterOption={(inputValue, option) => {
                return option.title.toLowerCase().includes(inputValue.toLowerCase());
            }}
            {...props}
        />
    );
};

export default PermissionsTransfer;
